interface Props {
    type: string;
    label?: string;
    name: string;
    register: any;
    placeholder?: string;
    errors: any; // Corrige FieldErrors<FieldErrors> a FieldErrors<FieldValues>
    disable?: boolean 
}

export const InputText = ({ type, label, name, register, placeholder, errors, disable }: Props) => {
    const errorStyle = "border border-red-500 rounded-md px-5 py-2 outline-none placeholder:text-red-500 focus:ring-2 focus:ring-red-200 transition-colors"
    const style = "border border-gray-300 rounded-md px-5 py-2 outline-none focus:border-blue-cole focus:ring-2 focus:ring-blue-cole-soft transition-colors"
    return (
        <div className="flex flex-col gap-1">
            {label && <span className="text-black dark:text-white text-sm">{label}</span>}
            <input
                type={type}
                placeholder={placeholder}
                className={!errors[name] ? style : errorStyle}
                {...register(name)}
                disabled={disable}
            />
            <p className="text-start text-xs text-red-500 y pl-2">
                {errors[name]?.message}
            </p>
        </div>
    );
};